// extracted by mini-css-extract-plugin
export default {"layoutContainer":"layout_layoutContainer__rcJwn","bodyContainer":"layout_bodyContainer__WBzXN","childreWrapper":"layout_childreWrapper__k7sY7"};